/* eslint-disable array-callback-return, eqeqeq */
import { deleteDatabase } from 'indexedb';
import config from '../config';
import { getToken, removeCookie, deleteToken } from './helpers';
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parse_JSON(response) {
    if (!response || response.status === 204 || response.status === 205) {
        return null;
    }

    return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function check_status(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    if (response.status === 401 && window.location.pathname !== "/app/signin") {
        return response
    }

    // const error = new Error(response.statusText);
    // error.response = response;
    // throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} path       The PATH of API, we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(options = {}, token_required = false, multipart = false) {
    const api_version = options.api_version || config.api_version;
    let headers = {}

    if (multipart === false) {
        headers = {
            ...options.headers,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        };
    }
    else {
        headers = {
            ...options.headers,
            'Access-Control-Allow-Origin': '*',
        };
    }

    options = {
        ...options,
        headers,
    };

    if (token_required) {
        if (options.path.includes('/api-token-auth/') == false) {
            options['headers']['Authorization'] = `TOKEN ${getToken()}`;
        }
    }

    options["headers"][
        "Authorization"
    ] = `${getToken()}`;

    return fetch(`${config.api_url}/${api_version}${options.path}`, options)
        .then(check_status)
        .then(parse_JSON)
        .then(data => {
            //   if (process.env.NODE_ENV === 'development') {
            //     console.log({ req: { url: config.api_url + options.path, options }, res: data });
            //   }
            if (!data) return { data: null };
            if (data.error) {
                if (data.message === "Invalid credentials") {
                    localStorage.removeItem('user_id');
                    sessionStorage.clear();
                    removeCookie("token")
                    deleteDatabase();
                    deleteToken();
                    window.location = "/"
                }
            }
            return data;
        });
}
